export default {
  appName: "Apna Kayasth Vivah",
  loading: "Loading...",
  subscriptions: "Subscriptions",
  ok: "OK",
  sessionExpired: "Your session has been expired",
  pleaseProvideAccess: "Please provide access",
  galleryPermissionDenied: "Gallery Permission Denied",
  turnOnPreciseLocation:
    "Please turn on precise location in order for best experience",
  openSettings: "Open Settings",
  cameraPermissionDenied: "Camera Permission denied",
  corruptedImage: "Image has been corrupted please use some other",
  cancel: "Cancel",
  unSupportedMediaType: "Unsupported Media Type.",
  selectImage: "Select Image",
  selectVideo: "Select Video",
  maxSize: "Maximum size allowed is 5MB",
  maxVideoSize: "Maximum video size allowed is 90 seconds",
  cameraNotAvailable: "Camera not available",
  validImage: "Please select a valid Image",
  pendingTaskForToday: "Pending Task For Today",
  viewAll: "View All",
  pleaseSelectChoice: "Please select your choice",
  galleryOrCamera: "Tap to open gallery or camera",
  camera: "Camera",
  gallery: "Gallery",
  uploadFile: "Upload File",
  email: "Email",
  password: "Password",
  login: "Login",
  signin: "Sign in",
  signup: "Sign up",
  submit: "Submit",
  name: "Name",
  recipientName: "Recipient Name",
  cardHolderName: "Card Holder Name*",
  buildingHouseNumber: "Building/House Number",
  cardNumber: "Card Number",
  streetName: "Street Name",
  suburb: "Suburb",
  postalCode: "Postal Code",
  state: "State",
  expiryValidity: "Expiry/Validity",
  cvv: "CVV",
  // Validation messages
  invalidEmail: "Please enter valid Email.",
  passwordLength: "Password should be 8 digit or long.",
  checkPrivacyPolicy: "Please check the privacy policy",
  logout: "Logout",
  delete: "Delete",
  deleteAcc: "Delete Account",
  skip: "Skip",
  NoRecord: "No record found.",
  logoutAlert: "Are you sure you want to logout?",
  deleteAlert: "Are you sure you want to delete the account?",
  // screen message
  alredyAccount: "Already have an account? ",
  forgotPass: "Forgot Password?",
  forgotPassword: "Forgot Password",
  strongPassword:
    "Password should be at least 8 characters long including uppercase, lowercase, special characters, and Numbers.",
  forgotTag:
    "Please enter your email address, you will receive a link to create a new password via email",
  forgotSuccess:
    "A password reset link has been sent to your registered email address.",
  agree: "I agree to the ",
  privacyPolicy: "Privacy Policy.",
  imgRemoveSuccess: "Image removed successfully.",
  privacyPo: "Privacy Policy",
  termsCon: "Terms & Conditions",

  shippingAddress: "Shipping Address",

  legacy: "Legacy",

  totalAmount: "Total Amount",
  overView: "Overview",

  aboutIpsm:
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",

  btn_Con: "CONTINUE",
  btn_Signin: "Sign in",
  btn_send: "Send",
  btn_Signup: "Sign up",
  btn_GStart: "GET STARTED",
  register_n: "Register Now?",
  login_wg: "Login with Email",
  Password: "Password",
  npassword: "New password",
  cnpassword: "Confirm new password",
  rPassword: "Repeat Password",
  Forgot_p: "Forgot Password",
  dontAccount: "Don’t have an account ? ",
  name_p: "Profile name",
  fname: "First Name",
  lname: "Last Name",
  mobile: "Mobile Number",
  backSignin: "Back to sign in",
  createTicket: "Create Ticket",
  r_AddingUser: "Add a User",
  btn_Submit: "Submit",

  Referral_Code: "Referral Code",
  need_help: "Need help?",
  otp_tag: "We will send you a one time password on this",
  otp_v: "OTP Verification",
  otp_vTag: "Almost there, Please enter OTP sent on",
  otp_D_receive: "Didn't receive code? ",
  otp_T_receive: "Didn't receive code? Resend in",
  Resend_OTP: "Resend Code",
  seconds: "Seconds",

  tcRequired: "Please accept Terms & Conditions",
  nameRequired: "Please enter full name.",
  fNameRequired: "Please enter First name.",
  lNameRequired: "Please enter Last name.",
  dobRequired: "Please select Date of birth.",
  pinCodeRequired: "Please enter Pin code.",
  codeValidRequired: "Please enter valid 6-digit verification code.",
  stateRequired: "Please select state.",
  cityRequired: "Please enter City name.",
  address1Required: "Please enter Address Line 1",
  address2Required: "Please enter Address Line 2",

  codeRequired: "Please enter Verification code.",
  registerProfileImg: "Please upload profile image.",
  emailRequired: "Please enter Email address.",
  emailValidRequired: "Please enter valid Email address.",
  mobileRequired: "Please enter Mobile number.",
  mobileValidRequired: "Please enter valid 10 digit Mobile number.",
  passwordRequired: "Please enter Password.",
  rPasswordRequired: "Please enter repeat Password.",
  oldPasswordRequired: "Please enter old Password.",
  currentPasswordRequired: "Please enter Current Password.",
  newPasswordRequired: "Please enter new Password.",
  cNewPasswordRequired: "Please enter confirm new Password.",
  cPasswordRequired: "Please enter confirm Password.",
  strongPasswordRequired: "Password should be at least 8 characters long.",
  strongNewPasswordRequired:
    "New Password should be at least 14 characters long.",

  checkNewAndConfirmPassRequired:
    "Password and repeat password should be same.",
  checkNewAndConfirmNewPassRequired:
    "New password and confirm password should be same.",
  lorem:
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",

  Forgot_p_Tag:
    "Don't fret! Just type in your email and we will send you a code to reset your password!",

  highEdu: "Highest Education",
  jobStatus: "Job Status",
  Occupation: "Occupation",
  AnnualIncome: "Annual Income",

  fatherName: `Father's Name`,
  motherName: `Mother's Name`,
  dob: "Date of Birth",
  editProfileSucess: "User profile updated successfully.",
  registrationSucess:
    "User registration successful. Please log in to continue.",
  loginSucess: "User logged in successfully.",
  logoutSucess: "User logged out successfully.",
  deleteUserSucess: "User account has been deleted successfully.",
  heightFt: ["2ft", "3ft", "4ft", "5ft", "6ft", "7ft", "8ft"],
  heightIn: [
    "0in",
    "1in",
    "2in",
    "3in",
    "4in",
    "5in",
    "6in",
    "7in",
    "8in",
    "9in",
    "10in",
    "11in",
  ],
  profileFor: ["Self", "Relative", "Daughter", "Son"],
  jobType: ["Private", "Government", "Self Employed", "Student", "Other"],
  genderType: ["Male", "Female", "Other"],
  maritalStatus: ["Single", "Widower", "Divorced", "Separated"],
  mother_tounge: [
    "Hindi",
    "English",
    "Marathi",
    "Bengali",
    "Gujarati",
    "Punjabi",
    "Tamil",
    "Telugu",
    "Malayalam",
    "Kannada",
    "Urdu",
    "Rajsthani",
    "Odia",
    "Assamese",
    "Maithili",
    "Bhojpuri",
    "Sanskrit",
    "Sindhi",
  ],
  religion_type: [
    "Hindu",
    "Muslim",
    "Christian",
    "Sikh",
    "Jain",
    "Buddhist",
    "Parsi",
  ],
  cast_type: ["Kayasth", "Brahmin", "Kshatriya", "Vaishya", "Shudra", "Other"],
  subCast_type: [
    "Srivastava",
    "Saxena",
    "Nigam",
    "Sinha",
    "Gaur",
    "Mathur",
    "Khare",
    "Bhatnagar",
    "Asthana",
    "Karna",
    "Lal",
    "kulshreshth",
  ],
  stateList: ["Bihar", "Uttar Pradesh"],
  living_Country: ["India", "Abroad"],
};
